import axios from "axios";
import Errores from "../utils/Errores.js";

let getCarreras = async function(busqueda) {
  let url = API.UNIVERSIDADES + "v1/instituciones/carreras";
  //let gratuidad = traducirGratuidad(busqueda.gratuidad);
  let params = {
    region: busqueda.region === "TODAS" ? null : busqueda.region,
    carrera: busqueda.carrera === "" ? null : busqueda.carrera,
    nombreInstitucion:
      busqueda.institucion === "TODAS" ? null : busqueda.institucion,
    busquedaExacta: busqueda.busquedaExacta,
    jornada: busqueda.jornada === "TODAS" ? null : busqueda.jornada
  };
  let resultado = await axios
    .get(url, { params })
    .then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      Errores.switchErrors(error);
      return null;
    });
  return resultado;
};

let getInstituciones = async function(busqueda) {
  let url = API.UNIVERSIDADES + "v1/instituciones";
  // let gratuidad = traducirGratuidad(busqueda.gratuidad);
  let params = {
    nombreInstitucion:
      busqueda.nombreInstitucion === "" ? null : busqueda.nombreInstitucion,
    region: busqueda.region === "TODAS" ? null : busqueda.region,
    tipoInstitucion:
      busqueda.tipoInstitucion === "TODAS" ? null : busqueda.tipoInstitucion,
    beneficiosEstatales:
      busqueda.beneficiosEstatales === "TODOS"
        ? null
        : busqueda.beneficiosEstatales
  };
  let resultado = await axios
    .get(url, { params })
    .then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      Errores.switchErrors(error);
      return null;
    });
  return resultado;
};

let getFichaCarrera = async function(idInstitucion, codigoCarrera, logo) {
  let url =
    API.UNIVERSIDADES +
    "v1/instituciones/" +
    idInstitucion +
    "/carreras/" +
    codigoCarrera;
  let params = {
    logo: logo
  };
  let carrera = await axios
    .get(url, { params })
    .then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      Errores.switchErrors(error);
      return null;
    });
  return carrera;
};

let getFichaInstitucion = async function(idInstitucion, logo) {
  let url = API.UNIVERSIDADES + "v1/instituciones/" + idInstitucion;
  let params = {
    logo: logo
  };
  let carrera = await axios
    .get(url, { params })
    .then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      Errores.switchErrors(error);
      return null;
    });
  return carrera;
};

let obtenerSimulacionPonderaciones = async function(config) {
  let url = API.UNIVERSIDADES + "v1/simulador-ponderacion/";
  let resultados = await axios
    .post(url, null, config)
    .then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      Errores.switchErrors(error);
      return null;
    });
  return resultados;
};

let enviarCorreoContacto = async function(correoContactoRequest, config) {
  let url = API.UNIVERSIDADES + "v1/correo/contacto";
  let resultados = await axios
    .post(url, correoContactoRequest, config)
    .then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      Errores.switchErrors(error);
      return null;
    });
  return resultados;
};

let enviarSimulacionCorreo = async function(
  correoSimuladorPonderacionRequest,
  config
) {
  let url = API.UNIVERSIDADES + "v1/correo/simulacion-ponderacion";
  let resultados = await axios
    .post(url, correoSimuladorPonderacionRequest, config)
    .then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      Errores.switchErrors(error);
      return null;
    });
  return resultados;
};

function traducirGratuidad(gratuidad) {
  let respuesta;
  switch (gratuidad) {
    case "ADSCRITA_GRATUIDAD":
      respuesta = true;
      break;
    case "NO_ADSCRITA_GRATUIDAD":
      respuesta = false;
      break;
    default:
      respuesta = null;
      break;
  }
  return respuesta;
}

export default {
  getCarreras,
  getFichaCarrera,
  getInstituciones,
  getFichaInstitucion,
  obtenerSimulacionPonderaciones,
  enviarCorreoContacto,
  enviarSimulacionCorreo
};



// WEBPACK FOOTER //
// ./src/services/ApiUniversidades.js